<template>
    <div class="contents group">
        <div class="builder-type-preview">
            <div v-for="attribute in attributes" :key="attribute.slug" class="level__options">
                <Field
                    v-model="modelValue[attribute.slug]"
                    :field="{ ...attribute, showHideBar: true, height: 'h-auto' }"
                    :dusk="`form-content-${levelIndex}-${attribute.slug}`"
                    label-position="none"
                />
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
import { toRefs } from 'vue';

const modelValue = defineModel({
    type: [Object, undefined],
});

interface Props {
    attributes?: any[];
    levelIndex?: number;
}

const props = withDefaults(defineProps<Props>(), {
    attributes: () => [],
    levelIndex: 0,
});

const { attributes, levelIndex } = toRefs(props);
</script>
